export const SET_AUTH = 'setOperator'
export const PURGE_AUTH = 'logOut'
export const SET_OPERATOR = 'setOperatorData'

export const SET_USER = 'setUserData'
export const PURGE_USER_AUTH = 'userLogOut'
export const SET_USER_AUTH = 'setUser'

export const SET_ERROR = 'setError'
export const PURGE_ERRORS = 'purgeErrors'

export const SET_BALANCE = 'setBalance'
export const SET_QUESTIONNAIRE_DONE = 'setQuestionnaireDone'

export const SAVE_PROMO = 'savePromo'



// WEBPACK FOOTER //
// ./src/store/mutations.type.js